import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { select, Store } from '@ngrx/store';
import { WindowRef } from '@shared/services/window-ref/window-ref.service';
import { switchMap, withLatestFrom } from 'rxjs';

import { GiftingMethodContinue, Go, Next } from '../../actions';
import { State } from '../../reducers/index';
import { selectSelectedPositions } from '../../selectors/cost-basis/cost-basis.selectors';
import { selectRouterState } from '../../selectors/router/common/router.selectors';

@Injectable()
export class GiftingMethodEffects {
  constructor(
    private actions$: Actions,
    private globalStore$: Store<State>,
    private windowRef: WindowRef,
  ) {}

  giftingMethodContinue$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GiftingMethodContinue),
        withLatestFrom(
          this.globalStore$.pipe(select(selectSelectedPositions)),
          this.globalStore$.pipe(select(selectRouterState)),
        ),
        switchMap(([, selectedPositions, routerReducer]) => {
          const currentPosition = +routerReducer.params.position_id;
          const onLastPosition = currentPosition >= selectedPositions.length;
          const path = ['secure', 'gifting', 'method', currentPosition + 1];

          return onLastPosition ? [Next()] : [Go({ path })];
        }),
      ),
    { dispatch: true },
  );
}

export const effects: any[] = [GiftingMethodEffects];
